import React from "react";
import styled from "styled-components";
import { Button, StyledText } from "../../../../components/common";
import { useTheme } from "../../../../hooks";

const ContestantVotingCard = ({
  imgUrl,
  teamName,
  businessName,
  businessDescription,
  onClick,
  isVoting
}) => {
  const { themeContext, theme } = useTheme();
  let mashupBackground =
    theme.colors[themeContext.activeTheme]["mashupBackground"];
  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];
  return (
    <ContestantCardContainer>
      <img
        width={115}
        height={115}
        src={imgUrl}
        alt="Winners Image"
        style={{ borderRadius: 10 }}
      />
      <StyledText style={{ margin: 0 }}>{teamName}</StyledText>
      <StyledText
        style={{
          margin: 0,
          fontFamily: "MTNRegular",
          color: "#7F7F7F",
          fontSize: 12,
        }}
      >
        {businessName}
      </StyledText>
      <StyledText style={{ fontFamily: "MTNRegular" }}>
        {businessDescription}
      </StyledText>
      {isVoting && (
        <Button
          style={{ backgroundColor: background, width: "60%" }}
          onClick={onClick}
        >
          <StyledText color="white">Vote</StyledText>
        </Button>
      )}
    </ContestantCardContainer>
  );
};

export default ContestantVotingCard;

const ContestantCardContainer = styled.div`
  width: 90%;
  display: flex;
  flex-direction: column;
  background-color: white;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  margin: 20px;
  padding: 15px;
  overflow: auto;
  align-items: center;
  text-align: center;
`;
